import { Box, InputAdornment, styled, TextField, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import SearchIcon from 'icons/Search.icon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export const Route = createFileRoute('/(admin)/_admin/admin-companies')({
  component: RouteComponent,
})

const StyledSearch = styled(TextField)(() => ({
    input: {
        lineHeight: '20px',
    },
    width: '50%',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'var(--Interviewer-Lightest-Black)',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
        border: '1px solid var(--Interviewer-Black)',
    },
    '&:focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid var(--Interviewer-Black)',
    },
}));

const GreenBadge = styled(Typography)({
    background: 'var(--Lightest-Green)',
    width: 'fit-content',
    padding: '4px 16px',
    fontSize: '16px',
    fontWeight: '700',
    color: 'var(--Interviewer-Green)',
    margin: 'auto',
    borderRadius: '100px'
})

const GrayBadge = styled(Typography)({
    background: 'var(--Light-Gray)',
    width: 'fit-content',
    padding: '4px 16px',
    fontSize: '16px',
    fontWeight: '700',
    color: 'var(--Interviewer-Lightest-Black)',
    margin: 'auto',
    borderRadius: '100px'
})

function RouteComponent() {

    const { data, isLoading, error } = useQuery({
    queryKey: ['companies'],
    queryFn: async () => {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://interviewer.runasp.net/api/organizations/all', {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });
        console.log('API Response:', response.data);
        return response.data;
    }
    });
  return <>
    <Box sx={{backgroundColor: '#fff'}}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: '24px', px: '32px'}}>
            <Typography variant='h2'>Companies</Typography>
            <StyledSearch
                fullWidth
                type="search"
                slotProps={{
                input: {
                    startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                    ),
                },
                }}
                placeholder="Search placeholder text"
            />
        </Box>

        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead sx={{borderTop: '1px solid var(--Interviewer-Near-White)'}}>
                    <TableRow>
                        <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center',  gap: '4px'}}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <ApartmentOutlinedIcon fontSize='small' />
                                    <Typography>Company Name</Typography>
                                </Box>
                                <KeyboardArrowDownOutlinedIcon fontSize='small' />
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px'}}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <CalendarTodayOutlinedIcon fontSize='small' />
                                    <Typography>Data Joined</Typography>
                                </Box>
                                <KeyboardArrowDownOutlinedIcon fontSize='small' />
                            </Box>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px'}}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <AccountBalanceWalletOutlinedIcon fontSize='small' />
                                    <Typography>Pricing Plan</Typography>
                                </Box>
                                <KeyboardArrowDownOutlinedIcon fontSize='small' />
                            </Box>
                        </TableCell> */}
                        <TableCell align="center">
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px'}}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <ShowChartOutlinedIcon fontSize='small' />
                                    <Typography>Status</Typography>
                                </Box>
                                <KeyboardArrowDownOutlinedIcon fontSize='small' />
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((item: any) => (
                        <TableRow key={item.organizationName}>
                            <TableCell component="th" scope="row">
                                <Typography sx={{fontWeight: '700', fontSize: '16px', color: 'var(--Interviewr-black)'}}>{item.organizationName}</Typography>
                            </TableCell>
                            <TableCell align="center">
                                <Typography sx={{fontSize: '16px', fontWeight: '500', color: 'var(--Interviewr-black)'}}>{item.dateJoined}</Typography>
                            </TableCell>
                            {/* <TableCell align="center">
                                <Typography sx={{fontSize: '16px', fontWeight: '500', color: 'var(--Interviewr-black)'}}>{item.active}</Typography>
                            </TableCell> */}
                            <TableCell align="center">
                                {item.active ? (
                                    <GreenBadge>Active</GreenBadge>
                                ) : (
                                    <GrayBadge>Canceled</GrayBadge>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Box>
  </>
}
